import classNames from 'classnames';
import React from 'react';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import FlairIcon from '../../../../../../atomic/atoms/FlairIcon';
import StringToHtml from '../../../../../../components/StringToHtml';
import { GoalBase, GoalId } from '../types';
import { GoalCardItem } from './GoalCardItem';

export type Props = {
  groupName: string;
  groupDescription?: string;
  goals: GoalBase[];
  onGoalClick: (goalId: GoalId) => void;
};

const i18prefix = 'performanceReview.goals2.goalStatusCard.';

export const GoalStatusCard: React.FC<Props> = ({
  groupName,
  groupDescription,
  goals,
  onGoalClick,
}) => {
  const { t } = useTranslation();

  return (
    <Card>
      <Card.Body>
        <div className="d-flex justify-content-between mb-3">
          <div className="d-flex align-items-center gap-2">
            <Card.Title as="h3" className="mb-0">
              {groupName}
            </Card.Title>
            {groupDescription && (
              <GroupTooltip
                groupName={groupName}
                groupDescription={groupDescription}
              />
            )}
          </div>
          <GoalsCounter>
            {goals.length +
              ' ' +
              t(i18prefix + 'goal', { count: goals.length })}
          </GoalsCounter>
        </div>
        <div className={classNames('d-flex', 'flex-column', 'gap-3')}>
          {goals.map((goal) => (
            <GoalCardItem key={goal.id} goal={goal} onClick={onGoalClick} />
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

const GroupTooltip = ({
  groupName,
  groupDescription,
}: {
  groupName: string;
  groupDescription: string;
}) => {
  return (
    <OverlayTrigger
      overlay={
        <Tooltip id={`group-description-tooltip-${groupName}`}>
          <StringToHtml text={groupDescription} />
        </Tooltip>
      }
      placement="top">
      <FlairIcon icon="phosphor-info" size="sm" role="button" />
    </OverlayTrigger>
  );
};

const GoalsCounter = ({
  className,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...rest} className={classNames('fs-4', 'fw-bold', className)} />
);
